import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ControlledInput, DialogTitleWithClose } from '../../../shared';
import { ISaveCardSet } from '../../models';
import { useCardSetSchema } from '../../validators';
import { useSaveCardSet } from '../../hooks/card-set.hook';

interface Props {
    show: boolean;
    handleClose: () => void;
}

export const CreateCardSet: FC<Props> = ({ show, handleClose }) => {
    const { t } = useTranslation();
    const { mutateAsync: createCardSet, isPending: isCreatingCardSet } = useSaveCardSet();

    const form = useForm<ISaveCardSet>({
        resolver: yupResolver(useCardSetSchema()),
        mode: 'onSubmit',
    });

    useEffect(() => {
        form.reset();
    }, [form, form.reset, show]);

    const onSubmit = async (data: ISaveCardSet) => {
        await createCardSet({ data });
        handleClose();
    };
    return (
        <Dialog open={show} onClose={handleClose}>
            <FormProvider {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                    <DialogTitleWithClose onClose={handleClose}>{t('newCardSet')}</DialogTitleWithClose>
                    <DialogContent>
                        <Box sx={{ pt: 1, minWidth: 500 }}>
                            <ControlledInput name={`countCards`} label={t('countCards')} required type="number" />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={isCreatingCardSet}
                            startIcon={<CircularProgress size={16} />}
                        >
                            {t('save')}
                        </Button>
                        <Button onClick={handleClose} color="secondary">
                            {t('cancel')}
                        </Button>
                    </DialogActions>
                </form>
            </FormProvider>
        </Dialog>
    );
};
